import weixin from '@/libs/app/weixin';
import { util } from '@/libs/utils';
import { miniRoutes } from '@/libs/utils/consts';
import RouteTrack from '@/libs/utils/log/track';
import store from '@/store';
import get from 'lodash/get';
import Vue from 'vue';
import Router from 'vue-router';
import wx from 'weixin-js-sdk';
import routes from './routers';

function setTitle(to) {
  // eslint-disable-next-line
  to.matched.some((record) => {
    document.title = record.meta.title || process.env.VUE_APP_TITLE;
  });
}

const router = new Router({
  mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
    };
  },
  routes,
});
router.beforeEach(async (to, from, next) => {
  // 小程序webview相关逻辑
  if (store.state.isMinProgram) {
    // hash值的修改不会重新刷新webview
    // 小程序支付成功后返回h5需要执行成功的回调，通过hash值/miniPay=success判断支付成功
    if (to.hash.includes('#/miniPay=success')) {
      store.dispatch('getHomeConfig')
      if (typeof store.state.miniPayCallback === 'function') {
        store.state.miniPayCallback()
      }
    }
    if (!to.query.appid) {
      let url = miniRoutes[to.path] || `/pages/webview/index?route=${encodeURIComponent(to.fullPath)}`
      wx.miniProgram.navigateTo({
        url,
      })
      next(false)
      return
    }
  }
  // 小程序webview相关逻辑 ------------- end
  // 检查是否在退款黑名单中，如果是则跳转到拦截申诉页面
  // 允许访问拦截申诉页面和申诉页面
  const allowedPaths = ['/thunder/intercept_appeal', '/thunder/appeal', '/popup-sandbox', '/ad-preview', '/popup-ab-compare'];
  const allowedNames = ['intercept_appeal', 'appeal', 'PopupSandbox', 'AdPreview', 'popupAbCompare'];
  if (store.state.is_refund_black === 1
    && !allowedPaths.includes(to.path)
    && !allowedNames.includes(to.name)) {
    next('/thunder/intercept_appeal');
    return;
  }
  // 设置title
  setTitle(to);
  store.commit('CLOSE_PAY_PANEL');
  // 判断是否授权,如果未授权则跳到授权
  if (process.env.NODE_ENV !== 'development') {
    weixin.getOpenID(to.path, to.query);
  }
  store.commit('SAVE_TOGGLE_SKELETON', false);
  if (util.skeletonCheckRoute(to.path) && !to.name?.startsWith('HOME_')) {
    store.commit('SAVE_TOGGLE_SKELETON', util.skeletonCheckRoute(to.path, 'getPath'));
  }
  // 没次切换路由更新一次
  store.commit('SET_FROM_TYPE', to.fullPath);
  // 页面不显示遥控的name放入notPlayControl数组中
  const notPlayControl = [
    'home',
    'singGift',
    'bless_sort',
    'interact',
    'photo',
    'photo_pag',
    'expression',
    'mv',
    'charge',
    'vip',
    'nearby',
    'nearbyKtv',
    'nearbyComments',
    'simple_index',
    'simple_ordered',
    'send_video',
    'customer',
    'invite',
    'nobind',
    'bar',
    'vipSuccess',
    'code',
    'myMusicRecordShare',
    'argument',
    'nearbyArgument',
    'send_success',
    'gift',
    'opening_effect',
    'opening_pag_effect',
    'high_song',
    'songWordsPlay',
    'YouxuanKtv',
    'privateSearch',
    'feedback',
    'intercept',
    'nosong',
    'vipRights',
    'vipPlus',
    'thunder_gift',
    'photov2_doutu',
    'photo_doutu',
    'electronic_music_party',
    'electronic_music_party_selected',
    'electronic_music_party_starting',
    'goodgift',
    'squareAgreement',
    'role',
    'xiaoai_bless',
    'banzou_vip',
    'ad',
    'tabManage',
    'vipGivevip',
    'vipPresentvip',
    'lk_test',
    'order_test',
    'order_shopcar',
    'order_bill',
    'bless_pag1',
    'disco_pag',
    'pag_add_receiver',
    'translate_songlist',
    'giftSpoof',
    'customerEdit',
    'equity_vip',
    'lkvip_home',
    'lkvip_pay',
    'lkvip_pay2',
    'lkvip_error',
    'aigc_create',
    'aigc_result',
    'aigc_pag',
    'aigc_history',
    'HOME_SINGER',
    'HOME_TOPS',
    'HOME_GEDAN',
    'HOME_VHOT',
    'video',
    'discoParty',
    'searchFeedback',
    'appmusic',
    'adopt',
    'adopt_song',
    'help',
    'classified_songlist',
    'recordList',
    'help_new',
    'intercept_appeal',
    'appeal',
    'PopupSandbox',
    'AdPreview',
    'popupAbCompare',
  ];
  // 配置遥控按钮初始位置
  const special_control = {
    singerdetail: '29.2vw',
    orderedSong: '29.2vw',
    top: '29.2vw',
    searchSongs: '29.2vw',
  };
  if (special_control[to.name]) {
    store.commit('SET_SPECIAL_CONTROL', special_control[to.name]);
  }
  if (notPlayControl.indexOf(to.name) >= 0) {
    store.commit('SHOW_PLAY_CONTROL', false);
  } else {
    store.commit('SHOW_PLAY_CONTROL', true);
  }
  store.commit('SET_CONTROL_PAD', false);
  next();
});

// 路有钩子：全局后置
router.afterEach((to, from) => {
  const isBlue = ['home', 'searchSongs', 'orderedSong', 'singer', 'tops', 'classified_songlist', 'singerdetail'].includes(to.name) || to.name.includes('HOME');
  // 只要是首页就使用蓝色主题，其他页面使用light主题
  const theme = isBlue ? 'blue' : 'light';

  // 根据当前路由设置主题
  store.commit('SET_THEME', theme);
  store.commit('SET_APP_HISTORY', window.history.length)
  if (store.state.statistics.routeTrack) {
    store.state.statistics.routeTrack.unload()
  }
  const routeTrack = new RouteTrack({
    name: to.name,
    path: to.path,
  })
  store.commit('SET_ROUTE_TRACK', routeTrack)

  if (!from.name) return;
  store.commit('SET_ORDER_LIST', true)
  store.commit('SET_INTERVAL_ORDERLIST', false)
  // store.commit('INIT_ENTER_PAGE', false);
  // 不需要统计pv和uv的页面路由
  const notStatisticsPages = ['/thunder/code', '/thunder/nobind'];
  if (!notStatisticsPages.includes(to.path)) {
    store.commit('PAGE_STATISTICS', {
      url: to.fullPath || location.href,
      fromUrl: from.fullPath,
    });
  }
  // 小程序webview相关逻辑
  if (to.query.appid) {
    store.commit('SAVE_TOGGLE_SKELETON', '');
    store.commit('SAVE_MINIPAY_CALLBACK', '')
    Vue.$fetchLoading.close()
  }// 小程序webview相关逻辑 ------------- end
});

/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = get(router, 'history.pending.fullPath', '');
  if (isChunkLoadFailed && targetPath) {
    router.replace(targetPath);
  }
});

export default router;
